module.exports = {"title":"Password","description":"Please enter your password to unlock the Presale.","submit":"Submit"}


//////////////////
// WEBPACK FOOTER
// ./src/components/EventListing/PasswordModal/locales/fr.json
// module id = 1333
// module chunks = 0